"use client";

import { Box, Typography } from "@mui/material";
import { draftKingsCampaign } from "../campaigns/draft-kings";
import { PORTAL_MAX_WIDTH, portalFont } from "../partnerTheme";
import CampaignHero from "./CampaignHero";
import OfferingOverviewSection from "./OfferingOverviewSection";
import ExperienceJourneySection from "./ExperienceJourneySection";
import CampaignOverviewGrid from "./CampaignOverviewGrid";
import ActivationCards from "./ActivationCard";
import PlatformPerformanceTable from "./PlatformPerformanceTable";
import PerformanceKpis from "./MetricCard";
import PhotoGallery from "./PhotoGallery";
import ReportPdfDownload from "./ReportPdfDownload";
import CampaignClosingCTA from "./CampaignClosingCTA";
import { dkStadiumConfig } from "../campaigns/draft-kings-stadium";

/**
 * Comedy Tapings tab. Reuses the existing DraftKings tapings case-study campaign
 * and results sections without modifying the standalone /partners/draft-kings route.
 */
export default function DraftKingsTapingsTab() {
  const campaign = draftKingsCampaign;

  return (
    <Box>
      {campaign.sampleDisclaimer ? (
        <Box sx={{ maxWidth: PORTAL_MAX_WIDTH, mx: "auto", px: { xs: 2.5, md: 4 }, pt: 2 }}>
          <Box
            role="note"
            sx={{
              px: 2,
              py: 1.25,
              borderRadius: "12px",
              border: `1px solid color-mix(in srgb, ${dkStadiumConfig.accentColor} 40%, transparent)`,
              bgcolor: `color-mix(in srgb, ${dkStadiumConfig.accentColor} 10%, transparent)`,
            }}
          >
            <Typography sx={{ fontFamily: portalFont, fontSize: { xs: "0.8125rem", md: "0.875rem" }, color: "#fff", lineHeight: 1.45 }}>
              {campaign.sampleDisclaimer}
            </Typography>
          </Box>
        </Box>
      ) : null}

      <CampaignHero campaign={campaign} />

      {campaign.offeringOverview ? <OfferingOverviewSection overview={campaign.offeringOverview} /> : null}
      {campaign.experienceJourney ? <ExperienceJourneySection journey={campaign.experienceJourney} /> : null}

      <CampaignOverviewGrid
        fields={campaign.glanceFields}
        eyebrow={campaign.glanceSection ? campaign.glanceSection.eyebrow ?? "" : undefined}
        title={campaign.glanceSection ? campaign.glanceSection.title ?? "" : undefined}
      />
      <ActivationCards
        eyebrow={campaign.activationsSection.eyebrow}
        title={campaign.activationsSection.title}
        description={campaign.activationsSection.description}
        activations={campaign.activations}
      />
      <PlatformPerformanceTable data={campaign.platformPerformance} />
      <PerformanceKpis
        eyebrow={campaign.kpiSection.eyebrow}
        title={campaign.kpiSection.title}
        description={campaign.kpiSection.description}
        groups={campaign.kpiSection.groups}
      />
      <PhotoGallery
        eyebrow={campaign.gallery.eyebrow}
        title={campaign.gallery.title}
        description={campaign.gallery.description}
        images={campaign.gallery.images}
        pendingMessage={campaign.gallery.pendingMessage}
      />
      {campaign.assets.reportPdf ? <ReportPdfDownload campaign={campaign} /> : null}
      <CampaignClosingCTA closing={campaign.closing} />
    </Box>
  );
}
